module.exports = __webpack_public_path__ + "static/img/shouzhi.303cba0d.png";